/**
 * FILE: apps/hub/src/components/ThemeAwareToaster.tsx
 * PURPOSE: Sonner toaster that follows the current Hub theme.
 */

import { Toaster } from 'sonner'
import { useTheme } from '@/hooks/useTheme'

export function ThemeAwareToaster() {
  const { resolvedTheme } = useTheme()
  return <Toaster richColors position="top-right" theme={resolvedTheme} />
}
